import { Skeleton } from 'antd';
import { SectionSummaryPanel } from './components';
import { useSubmissionSectionSummaryV3 } from './hooks';
import { OverviewHeader, OverviewProgress, QuestionGrid, SummaryBody, SummaryCard, SectionDivider, SectionHeader, SectionPanel, SectionTitle } from './submission-section-summary-v3.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var questionSkeletonStyle = {
  width: 44,
  height: 40,
  borderRadius: 8
};

var SectionSummarySkeleton = function SectionSummarySkeleton() {
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs(SectionPanel, {
      children: [/*#__PURE__*/_jsxs(SectionTitle, {
        $isExpanded: true,
        children: [/*#__PURE__*/_jsx(SectionHeader, {
          children: /*#__PURE__*/_jsx(Skeleton.Input, {
            active: true,
            size: "small",
            style: {
              width: 112
            }
          })
        }), /*#__PURE__*/_jsx(Skeleton.Input, {
          active: true,
          size: "small",
          style: {
            width: 56
          }
        })]
      }), /*#__PURE__*/_jsxs(QuestionGrid, {
        children: [/*#__PURE__*/_jsx(Skeleton.Button, {
          active: true,
          shape: "square",
          style: questionSkeletonStyle
        }), /*#__PURE__*/_jsx(Skeleton.Button, {
          active: true,
          shape: "square",
          style: questionSkeletonStyle
        }), /*#__PURE__*/_jsx(Skeleton.Button, {
          active: true,
          shape: "square",
          style: questionSkeletonStyle
        }), /*#__PURE__*/_jsx(Skeleton.Button, {
          active: true,
          shape: "square",
          style: questionSkeletonStyle
        }), /*#__PURE__*/_jsx(Skeleton.Button, {
          active: true,
          shape: "square",
          style: questionSkeletonStyle
        })]
      })]
    }), /*#__PURE__*/_jsx(SectionDivider, {})]
  });
};

export var SubmissionSectionSummaryV3 = function SubmissionSectionSummaryV3(props) {
  var sectionSummaries = props.sectionSummaries,
      label = props.label,
      isLoadingGetQuestions = props.isLoadingGetQuestions,
      hideOverviewHeader = props.hideOverviewHeader;

  var _useSubmissionSection = useSubmissionSectionSummaryV3(props),
      sectionItems = _useSubmissionSection.sectionItems,
      totalAnswered = _useSubmissionSection.totalAnswered,
      totalQuestions = _useSubmissionSection.totalQuestions,
      isCollapsible = _useSubmissionSection.isCollapsible,
      selectQuestion = _useSubmissionSection.selectQuestion,
      toggleSection = _useSubmissionSection.toggleSection;

  if (isLoadingGetQuestions || !sectionSummaries) {
    return /*#__PURE__*/_jsxs(SummaryCard, {
      "aria-busy": true,
      children: [!hideOverviewHeader && /*#__PURE__*/_jsxs(OverviewHeader, {
        children: [/*#__PURE__*/_jsx(Skeleton.Input, {
          active: true,
          size: "small",
          style: {
            width: 140
          }
        }), /*#__PURE__*/_jsx(Skeleton.Input, {
          active: true,
          size: "small",
          style: {
            width: 40
          }
        })]
      }), /*#__PURE__*/_jsxs(SummaryBody, {
        children: [/*#__PURE__*/_jsx(SectionSummarySkeleton, {}), /*#__PURE__*/_jsx(SectionSummarySkeleton, {})]
      })]
    });
  }

  return /*#__PURE__*/_jsxs(SummaryCard, {
    children: [!hideOverviewHeader && /*#__PURE__*/_jsxs(OverviewHeader, {
      children: [/*#__PURE__*/_jsx("span", {
        children: label.overview
      }), /*#__PURE__*/_jsx(OverviewProgress, {
        children: "".concat(totalAnswered, "/").concat(totalQuestions)
      })]
    }), /*#__PURE__*/_jsx(SummaryBody, {
      children: sectionItems.map(function (sectionItem) {
        return /*#__PURE__*/_jsx(SectionSummaryPanel, {
          sectionItem: sectionItem,
          isLoadingQuestions: isLoadingGetQuestions,
          isCollapsible: isCollapsible,
          label: label,
          onToggleSection: toggleSection,
          onSelectQuestion: selectQuestion
        }, sectionItem.id);
      })
    })]
  });
};